import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export var dayMonthFormat = 'D MMMM';
export var yearFormat = 'YYYY';
export var timeFormat = 'HH:mm';
export var dateFormat = dayMonthFormat + " " + yearFormat;
export var datetimeFormat = dateFormat + " " + timeFormat;
export var numberedDateFormat = "DD.MM." + yearFormat;
//# sourceMappingURL=dayjsUtils.js.map